import MyService from '../../service';

const PromotionApi = {
  getAll: async () => {
    let promotions = null;
    await MyService.getRequestData('/promotions')
      .then((result) => (promotions = result.data))
      .catch((err) => console.log(err));
    return promotions;
  },
  getDetailsPromotionByIdOrCode: async (promo_id_code) => {
    let promotion = null;
    console.log('get promotion by promo_id or promo_code ', promo_id_code);
    await MyService.getRequestData(`/promotions/${promo_id_code}`)
      .then((result) => {
        promotion = result.data;
      })
      .catch((err) => console.log(err));
    return promotion;
  },
  create: async (promotion) => {
    let promo;
    console.log('add new promotion ', promotion);
    await MyService.postRequestData('/promotions/', promotion)
      .then((result) => {
        promo = result;
      })
      .catch((err) => console.log(err));

    return promo;
  },
  deletePromotion: async (promo_id) => {
    console.log('delete promotion promo_id', promo_id);
    return await MyService.deleteRequestData(`/promotions/${promo_id}`);
  },
  update: async (promo_id, params) => {
    console.log('update promotion promo_id', promo_id, params);
    return await MyService.putRequestData(`/promotions/${promo_id}`, params);
  },
};

export default PromotionApi;
